import * as React from 'react';

import { Avatar } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import logo from '../../components/assets/logo.svg';
import { changeHeaderColorByEnv } from '../../constants/Colors';

const styles = {
  header: {
    bgcolor: changeHeaderColorByEnv(),
    boxShadow: 'none'
  },
  headerInner: {
    '@media screen and (min-width:1400px)': {
      paddingLeft: '40px',
      paddingRight: '40px'
    }
  },
  headerTitle: {
    flexGrow: 1,
    fontFamily: 'Noto Sans JP, sans-serif',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  headerWrapper: {
    flexGrow: 1,
    position: 'sticky',
    top: 0,
    zIndex: 10
  },
  logo: {
    '@media screen and (max-width:480px)': {
      height: '28px',
      width: '105px'
    },
    borderRadius: 0,
    height: '40px',
    width: '150px'
  }
};

export default function Header(): React.ReactElement {
  return (
    <>
      <Box sx={styles.headerWrapper}>
        <AppBar position="static" sx={styles.header}>
          <Toolbar sx={styles.headerInner}>
            <Avatar alt="logo" src={logo} sx={styles.logo} />
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
}
